import { defineStore } from 'pinia';

export const useLanguageStore = defineStore({
    id: 'language',
    state: () => ({
        language: 'ja',
    }),
    getters: {
        getLanguageValue() {
            if ('ja' === this.language) {
                return '1';
            } else {
                return '2';
            }
        },
    },
    actions: {
        setLanguage(value) {
            this.language = value;
        },
    },
    persist: {
        //ローカルストレージに保存
        storage: localStorage,
    },
});
